import { render, staticRenderFns } from "./CollaborationCard.vue?vue&type=template&id=0e5b8553&scoped=true&"
import script from "./CollaborationCard.vue?vue&type=script&lang=ts&"
export * from "./CollaborationCard.vue?vue&type=script&lang=ts&"
import style0 from "./CollaborationCard.vue?vue&type=style&index=0&id=0e5b8553&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5b8553",
  null
  
)

export default component.exports